import { Typography } from "@mui/material";
import { Avatar, Box, Card, CardContent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import PaidIcon from '@mui/icons-material/Paid';
import PeopleIcon from '@mui/icons-material/People';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import useStyles from "./cardNumberStyle";
import { useNavigate } from "react-router-dom";

function CardsNumber() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const items = [
    {
      bgcolor: "primary.main",
      icon: <PaidIcon sx={{ color: "#fff" }} />,
      name: t("orders"),

      unitKey: "orders",
      click:()=>{
        navigate("/orders")
      },
      value: "26,789",
    },
    {
      bgcolor: "error.main",
      icon: <PeopleIcon style={{ color: "#fff" }} />,
      name: t("users"),

      unitKey: "users",
      click:()=>{
        navigate("/users")
      },
      value: "6,754",
    },
    {
      bgcolor: "warning.main",
      icon: <CreditScoreIcon style={{ color: "#fff" }} />,
      name: t("sales"),
      click:()=>{
        navigate("/sales")
      },

      unitKey: "sales",
      value: "52,789",
    },
  ];

  return (
    <>
      {items.map((item) => (
        <Card key={item.name} className={classes.card} onClick={item.click}>
          <CardContent className={classes.cardContent}>
            <Avatar
              aria-label={`${item.name} avatar`}
              sx={{ bgcolor: item.bgcolor, mr: 4, ml: 2 }}
            >
              {item.icon}
            </Avatar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography component="div" variant="h6">
                {item.value}
              </Typography>
              <Typography variant="body1"  component="div">
                {t(item.name)}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ))}
    </>
  );
}

export default CardsNumber;
